import {
    login,
    getUserInfo,
    GetUserInfoResDto,
    getPhoto,
    GetPhotoResDto,
    getTokenAsCode,
    getRsaPublicKey
} from '../api/base'
import global from './global'
import store from '@/store'
import router from '@/router'
import { replaceCompany } from '@/api/alipay-recharge'
import JSEncrypt from 'jsencrypt'

export interface UserDto {
    userId: string
    userName: string
    nickName: string
    phone: string
    sex: '0' | '1'
    avatar: string
    companyId: string
    isAdmin: boolean | number
    isPcAdmin: boolean | number
    isGsc: boolean
    isOpenEleSign: boolean
    isOpenPaySalary: boolean
    isOpenWesure: boolean
    isWaiting: boolean
    accountExpireInfo: any
}

class User {
    auditStatus = false
    isForbidInsure = false
    userId = 0
    userName = ''
    nickName = ''
    phone = ''
    sex = ''
    avatar = ''
    companyId = ''
    isAdmin = false
    isPcAdmin = false
    isSupPcAdmin = false // 是否超级管理员
    isWaiting = false
    companyName = ''
    isGsc = false
    isOpenEleSign = false
    isOpenPaySalary = false
    isOpenWesure = false
    accountExpireInfoStatus = 0
    wechatMchId = ''
    receiptId = 0
    bankName = ''
    bankNo = ''
    openBank = ''
    baseFlag = false
    proFlag = false

    waitLogin(): Promise<number> {
        return new Promise(resolve => {
            setInterval(() => {
                if (this.isWaiting) {
                    resolve(this.userId)
                }
            }, 300)
            if (this.isWaiting) {
                resolve(this.userId)
            }
        })
    }

    getPhoto(): Promise<GetPhotoResDto> {
        return getPhoto()
    }

    exit() {
        this.userId = 0
        global.token = ''
        store.state.tagsPages = []
        // sessionStorage.removeItem('token')
        // sessionStorage.removeItem('closeExpireDialog')
        // sessionStorage.removeItem('festivalClose')
        // sessionStorage.removeItem('festivalClose')
        sessionStorage.clear()
        store.commit('stopFileTimer')
        store.state.fileList = []
        store.state.intervalId = ''
        router.push({
            path: '/login'
        })
    }

    async login(data: {
        username: string
        password: string
        code: string
        uuid: string
    }) {
        let publicKey = window.localStorage.getItem('RSA_PUBLIC_KEY')
        if (!publicKey) {
            publicKey = await getRsaPublicKey()
            window.localStorage.setItem('RSA_PUBLIC_KEY', publicKey)
        }
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publicKey);
        const result = await login({
            ...data,
            password: encrypt.encrypt(data.password) || ''
        })
        global.token = result.token
        // sessionStorage.token = result.token
        return result
    }

    async switchLogin(data: {
        username: string | number,
        companyId: number | string
    }): Promise<GetUserInfoResDto> {
        const result = await replaceCompany(data)
        global.token = result.token
        sessionStorage.token = result.token
        return this.getUserInfo()
    }

    async getUserInfo() {
        const data: any = await getUserInfo()
        console.log(data, 'userinfouserinfouserinfouserinfo')
        this.auditStatus = data.user.auditStatus
        this.isForbidInsure = data.isForbidInsure
        this.userId = data.user.userId
        this.phone = data.user.phonenumber
        this.nickName = data.user.nickName
        this.userName = data.user.userName
        this.sex = data.user.sex
        this.isAdmin = data.user.admin
        this.isPcAdmin = data.user.isPcAdmin
        this.isSupPcAdmin = data.user.isSupPcAdmin
        this.avatar = data.user.avatar
        this.companyName = data.user.companyName
        this.companyId = data.bankInfo?.companyId != null ? String(data.bankInfo.companyId) : ''
        this.isGsc = data.isGsc
        this.isOpenEleSign = data.isOpenEleSign
        this.isOpenPaySalary = data.isOpenPaySalary
        this.isOpenWesure = data.isOpenWesure
        this.isWaiting = true
        this.accountExpireInfoStatus = data.accountExpireInfo.status
        this.wechatMchId = data.bankInfo.wechatMchId
        this.receiptId = data.bankInfo.receiptId
        this.bankName = data.bankInfo.bankName
        this.bankNo = data.bankInfo.bankNo
        this.openBank = data.bankInfo.openBank
        this.baseFlag = data.baseFlag
        this.proFlag = data.proFlag
        console.log(this.openBank, ' this.openBank')
        store.commit('setUser', {
            avatar: data.user.avatar,
            nickName: data.user.nickName,
            companyName: data.user.companyName,
            auditStatus: data.user.auditStatus
        })
        store.commit('setBankInfo', data.bankInfo)
        return data
    }

    async codeLogin(code: string) {
        return (await getTokenAsCode({
            code
        })).companyList
        // global.token = result.token
        // sessionStorage.token = result.token
        // return this.getUserInfo()
    }
}

export default new User()
